import { gql } from "@apollo/client";

export const GET_CLINICIAN = gql`
  query GetClinicianByOwner {
    clinicianByOwner {
      _id
      firstname
      lastname
      email
      phone
      onboarding_completed
      preferences {
        theme
        language
        display_settings {
          length_unit
          weight_unit
          timezone
          float_sensitivity
        }
        spino_pelvic_parameters
      }
    }
  }
`;
